import React, { useState } from 'react';
import styled from './index.module.scss';
//import { EFEmail } from '@/components/UI/svg/Footer';
import EFEmail from '@/components/UI/svg/Footer/Icon/EFEmail';
import { useGlobal } from '@/utils/useGlobal';
import { subscribe } from '@/service/vip';
import { message } from '@/components/UI/Message';

interface IEmarsysProps {
    defaultValue?: string;
    submitText: string;
    placeholder: string;
    source?: string;
    disabled?: boolean;
    successCallback?: any;
    errorCallback?: () => void;
}
const reg = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
const Emarsys: React.FC<IEmarsysProps> = ({
    defaultValue = '',
    submitText,
    placeholder,
    source = 'ECO_CREDITS_DAY',
    disabled = false,
    successCallback,
    errorCallback,
}) => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared');
    const [inputValue, setInputValue] = useState(defaultValue || '');
    const [loading, setLoading] = useState(false);
    const isDisabled = !reg.test(inputValue) || disabled;

    const handleSubmit = () => {
        setLoading(true);
        subscribe(inputValue, locale, source)
            .then((res) => {
                setLoading(false);
                if (res.code !== '0' && res.code !== '2058') {
                    errorCallback && errorCallback();
                    return message.error(res.message);
                }
                successCallback && successCallback(inputValue);
                setInputValue('');
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
                errorCallback && errorCallback();
            });
    };

    return (
        <div className={`${styled.emarsys_form}`}>
            <div className={`emarsys_main ${isDisabled ? 'disabled' : ''}`}>
                <div className="emarsys_input">
                    <span className="emarsys_icon">
                        <EFEmail />
                    </span>
                    <input
                        type="email"
                        value={inputValue}
                        pattern=".*"
                        title=""
                        onInput={(e) => setInputValue(e.target.value.trim())}
                        placeholder={placeholder ?? t('common.email_holder')}
                    />
                </div>
                <div className="emarsys_submit">
                    <button type="submit" disabled={isDisabled} className="emarsys_submit_button" onClick={handleSubmit}>
                        {submitText}
                    </button>
                </div>
            </div>
        </div>
    );
};
export default Emarsys;
